export * from './unauthorized-click-check-element.directive';
export * from './unauthorized-click-check-element.module';
